import { planTypes, COUNTRY_CODE_INDIA, AccountType } from "@/common/constants"
import { plansof } from "@/utils/chain"
import { flowTypes, pageConfig } from '@/common/service/page-config';

export const UseVerificationTypes = {
  No: 'No',
  CIN: 'CIN',
  EDU: 'EDU',
}

const checkCountryIndia = (getters) => {
  return (
    getters.addressInfo.country === COUNTRY_CODE_INDIA ||
    getters.addressInfo.accountHq === COUNTRY_CODE_INDIA
  )
}

const state = {
  useVerificationDetail: {
    taxAccountNumber: '',
    cinId: '',
    eduId: '',
  },
}


const getters = {
  useVerificationDetail: (state) => state.useVerificationDetail,
  hasUseFormVerified: (state, getters) => {
    if (getters.useVerificationType === UseVerificationTypes.CIN) {
      return Boolean(getters.useVerificationDetail.cinId && getters.useVerificationDetail.taxAccountNumber)
    } else if (getters.useVerificationType === UseVerificationTypes.EDU) {
      return Boolean(getters.useVerificationDetail.eduId && getters.useVerificationDetail.taxAccountNumber)
    } else {
      return false
    }
  },
  useVerificationType: (state, getters) => {
    if (
      getters.eduDomainRegList.find(item => item.test(getters.account.email)) ||
      getters.addressInfo.isForEdu ||
      getters.basicConfig.isCoppa ||
      getters.account?.accountType === AccountType.ACCOUNT_EDU_HOST ||
      plansof(getters.getSelectedPlans).parentCategory('ZONEDU','EDU', 'EDUST', 'ZONEDUSTU').has() ||
      plansof(getters.boughtPlans).parentCategory('ZONEDU','EDU', 'EDUST', 'ZONEDUSTU').has()
    ) {
      return UseVerificationTypes.EDU
    } else {
      return UseVerificationTypes.CIN
    }
  },
  needUseVerification: (state, getters) => {
    if (getters.disableBusinessVerification) {
      return false
    }
    if (
      [
        flowTypes.buyNow,
        flowTypes.basic2pro,
        flowTypes.edit,
        flowTypes.add2cart,
        flowTypes.zs2ze,
        flowTypes.add2trial,
        flowTypes.trial2paid,
      ].includes(pageConfig?.type)
    ) {
      let hasVerified = false
      if (getters.useVerificationType === UseVerificationTypes.EDU) {
        hasVerified = !!getters.basicConfig.businessVerificationStatus?.hasEduId
      } else if (getters.useVerificationType === UseVerificationTypes.CIN) {
        hasVerified = !!getters.basicConfig.businessVerificationStatus?.hasCinId
      }
      return (
        (
          plansof(getters.getSelectedPlans).type(planTypes.EVENT_SAAS_CORE, planTypes.EVENT_SAAS).has() ||
          plansof(getters.getSelectedPlans).parentCategory('ZET').has()
        ) &&
        checkCountryIndia(getters) &&
        !hasVerified
      )
    } else {
      return false
    }
  }
}

const mutations = {
  setUseVerificationDetail(state, data) {
    state.useVerificationDetail = data;
  },
}

export default {
  state,
  getters,
  mutations,
}
